<template>
  <div class="live-container">
    <!-- 腾讯云播放器 -->
    <video v-if="canPlay" class="player-container" id="J_prismPlayer_liveDetails"></video>
    <!--阿里云播放器容器-->
    <!-- <div v-if="canPlay" class="pre-video prism-player" id="J_prismPlayer_liveDetails"></div> -->
    <img v-else class="pre-img" :src="liveData.advanceImg" alt="壹心理">

    <!--兼容某些手机无法自动播放-->
    <div v-if="!isPlay && +liveStatus === 1 && canPlay" class="play-btn" @click="playLive">
      <img class="play-img" src="../../assets/images/play.png" alt="壹心理-直播预告">
      <p>{{ +liveData.showType === 2 ? '轻触收听语音直播' : '轻触立即观看' }}</p>
    </div>

    <!--付费课程不显示所有直播中的内容-->
    <!-- 语音直播（showType=2）只需展示背景图 -->
    <div
      :class="{
        'living-content': true,
        'broadcast': showBroadCastBg
      }"
      :style="{
        'backgroundImage': showBroadCastBg && liveData.backgroundImg ? `url(${liveData.backgroundImg})` : 'none'
      }"
    >
      <section class="section">
        <avatar-name-con
            :channelId="liveData.channelId"
            :name="liveData.channelName"
            :avatar="liveData.channelPortrait"
            :isFollow="!!liveData.isStar"
            :hideBtn="!canPlay || liveData.liveType === 7"
            @handleAttention="handleAttention"/>
        <div class="section-right">
          <avatar-group v-if="avatarList && avatarList.length > 0" :avatarArr="avatarList" :sum="liveData.assistant === 1 ? liveData.realSum : liveData.viewSum"></avatar-group>
          <!--        <div @click="goToList"><svg-icon icon-class="close"></svg-icon></div>-->
        </div>
      </section>

      <span class="special" v-if="special">精选</span>

      <!-- 广告浮窗 -->
      <!-- <section class="ad-pop-outside" v-if="liveData.advertList && liveData.advertList.length">
        <AdvertList :list="liveData.advertList"/>
      </section> -->
      <section class="ad-pop-outside" v-if="liveData.liveRoomAdImg && !(liveData.advertList && liveData.advertList.length)">
        <AdPop :liveRoomAdImg="liveData.liveRoomAdImg" :liveRoomAdUrl="liveData.liveRoomAdUrl" />
      </section>

      <!--直播暂停状态处理-->
      <section class="live-pause" v-if="+liveStatus === 3 && canPlay">
        主播喝口水，请稍等片刻哦~
      </section>

      <!--进行中和暂停时才显示弹幕等内容-->
      <div v-if="+liveStatus === 1 || +liveStatus === 3">

        <section class="section-bottom">
          <!--礼物打赏模块-->
          <gift-animate :newGift="newGift"></gift-animate>

          <!--弹幕-->
          <barrage class="barrage-con" :msgArr="chatList" :newMsg="newMsg" @dragOperation="dragOperation">
            <template v-slot:msgItem="msgItem">
              <!--用户弹幕 chatList里没有barrageType字段-->
              <div v-if="!msgItem.item.barrageType || msgItem.item.barrageType === 1" class="item-con msg-item">
                <div>
                  <div class="assistant-con" v-show="msgItem.item.assistant">
                    <img class="assisstant-img" src="../../assets/images/assistant.png" alt="壹心理">
                    助手
                  </div>
                  <span class="nickname">{{ decodeURI(msgItem.item.nickname || '游客') }}：</span>
                  <span class="content">{{ decodeURI(msgItem.item.content || '') }}</span>
                </div>
              </div>

              <!--用户加入直播间-->
              <div v-else-if="msgItem.item.barrageType === 2" class="msg-item join-item">
                <span class="nickname">{{ decodeURI(msgItem.item.nickname || '') }}</span>
                <span class="content">加入直播间</span>
              </div>

              <!--用户关注主播-->
              <div v-else-if="msgItem.item.barrageType === 3" class="msg-item attention-item">
                <span class="nickname">{{ decodeURI(msgItem.item.nickname || '') }}</span>
                <span class="content">关注了主播</span>
              </div>

              <!--用户给主播送礼-->
              <div v-else-if="msgItem.item.barrageType === 4" class="msg-item gift-item">
                <span class="nickname">{{ decodeURI(msgItem.item.nickname || '') }}</span>
                <span class="content">送出{{ msgItem.item.giftName }}&nbsp;x{{ msgItem.item.giftNum }}</span>
              </div>
            </template>
          </barrage>

          <!--每日金句-->
          <div class="daily-handle" v-if="liveData.dailyImg">
            <DailyPop :dailyContent="liveData.dailyContent" :dailyImg="liveData.dailyImg" />
          </div>

          <!--底部操作按钮-->
          <div v-if="canPlay" class="live-fun-container">
            <div v-if="!isYixinliApp" class="barrage-btn" @click.stop="openBarragePopup">
              <svg-icon icon-class="edit" class-name="func-btn"></svg-icon>我想说
            </div>
            <div v-else v-open-app="openAppConfig">
              <div v-if="viewable" class="left-btn" @click="watchClick">
                去APP参与直播互动
                <svg-icon icon-class="arrow" class-name="func-btn"></svg-icon>
              </div>
              <Deblocking v-else class="func-btn" :living="true" :handlewxLogin="handlewxLogin" :groupQrcode="groupQrcode" :pageTitle="liveData.liveTitle" ref="taskList" />
            </div>

            <div class="btn-group" v-open-app="openAppConfig">
              <template v-if="liveData.liveType !== 7">
                <!--如有连麦申请，则不显示解梦申请-->
                <div v-show="!liveData.liveConnect && liveData.liveDream" class="bottom-btn" @click="dreamApply">
                  <img src="../../assets/images/moon.png" alt="壹心理直播-解梦申请">
                  <img class="tag" src="../../assets/images/dream.png" alt="壹心理直播-解梦申请">
                </div>

                <div v-show="liveData.liveConnect" class="bottom-btn" @click="microConnectApply">
                  <img src="../../assets/images/microphone.png" alt="壹心理直播-连麦申请">
                  <img class="tag" src="../../assets/images/micro.png" alt="壹心理直播-连麦申请">
                </div>

                <!--<div class="bottom-btn" @click="handleShare">
                  <img src="../../assets/images/share.png" alt="壹心理直播-分享">
                </div>-->

                <div class="bottom-btn cover-btn" @click="reward">
                  <img src="../../assets/images/reward.png" alt="壹心理直播-打赏">
                </div>
              </template>

              <div v-if="liveData.advertList && liveData.advertList.length" class="bottom-btn cart-btn" @click.stop="shoppingCartVisible=true">
                <img src="../../assets/images/cart.svg" alt="壹心理直播-购物车">
              </div>

              <div class="bottom-btn" @click.stop="likeClick">
                <like-canvas ref="like" class="like-container" v-slot:default :sum="liveData.likeSum">
                  <div v-if="liveData.likeSum" class="num">{{ liveData.likeSum | millionNum }}</div>
                  <img src="../../assets/images/like.png" alt="壹心理直播-点赞">
                </like-canvas>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!--直播结束-->
      <div v-else-if="+liveStatus === 2 && canPlay" class="end-con">
        本场直播已结束
      </div>

      <!--连麦模块显示-->
      <section v-show="connectStatus" class="connect-micro-sec">
        <div class="micro-connect" v-if="connectStatus === 2">
          <p>主播请求连麦</p>
          <div v-open-app="openAppConfig" @click="goToApp">去App连接</div>
        </div>
        <div class="micro-connecting" v-else>
          <img src="../../assets/images/microphone.png" alt="壹心理-连麦">
          <p>连麦中</p>
        </div>
      </section>
    </div>

    <!--付费课程拦截提示-->
    <section v-if="liveData.lessonId" class="course-con">
      <join-course :lesson-id="liveData.lessonId" :money="coursePrice"></join-course>
    </section>

    <!-- 禁止h5端播放的直播引导到app播放提示文案 -->
    <section class="download-con" v-open-app="openAppConfig" v-if="+liveData.onlyApp && !(+liveData.lessonId)">
      <div>
        去壹心理App围观直播
        <svg-icon icon-class="arrow" class-name="func-btn"></svg-icon>
      </div>
    </section>

    <!--关注主播二维码弹框-->
    <dialog-tip v-if="attentionDialog" @close="closeAttentionDialog">
      <template>
        <div class="dialog-content">
          <p class="conteng-title">你已关注主播</p>
          <p class="content-tip">微信内扫描或长按识别二维码，<br/>关注公号，第一时间掌握Ta的直播资讯</p>
          <div class="content-scan">
            <img class="scan-img" src="../../assets/images/scan.jpg" alt="壹心理-公开课">
          </div>
        </div>
      </template>
    </dialog-tip>

    <mt-popup v-model="barragePopupVisible" position="bottom" style="width: 10.01rem;">
      <div class="barrage-input">
        <div class="input-header">
          <span @click="barragePopupVisible=false">
            <svg-icon icon-class="close" class-name="btn-close"></svg-icon>
          </span>
          <span class="title">发送弹幕</span>
          <span @click="handleSendBarrage">
            <svg-icon icon-class="check" class-name="btn-confirm"></svg-icon>
          </span>
        </div>
        <mt-field v-model="barrageContent" type="textarea" rows="4"></mt-field>
      </div>
    </mt-popup>

    <mt-popup v-model="fullScreenAdVisible">
      <div v-if="fullScreenAd" class="full-screen-ad">
        <a :href="fullScreenAd.adUrl" class="ad-link">
          <img :src="fullScreenAd.adImg" alt="">
        </a>
        <span class="close-btn" @click="fullScreenAdVisible=false">
          <i></i>
        </span>
      </div>
    </mt-popup>

    <shoppingCart :visible.sync="shoppingCartVisible" :list="liveData.advertList"></shoppingCart>
  </div>
</template>

<script>
  import AvatarNameCon from 'components/AvatarNameCon'
  import AvatarGroup from 'components/AvatarGroup'
  import Barrage from 'components/Barrage'
  import LikeCanvas from 'components/LikeCanvas'
  import AdPop from 'components/AdPop'
  import DailyPop from 'components/DailyPop'
  import Deblocking from 'components/Deblocking'
  import { sockjs, downloadApp, wx, wxShare, fitVideo, shareBind, viewable } from 'mixins'
  import { getLiveDetail, starChannel } from 'api/live'
  import { getToken, getUserId, getOpenId, aliplayerReadyHandle, isWifi, centToYuan } from '@/utils/utils'
  import DialogTip from 'components/DialogTip'
  import { getPlatform, getRunningEnv } from 'lib/tools/getPlatform'
  import giftAnimate from "./giftAnimate";
  import JoinCourse from "../../components/JoinCourse/index";
  // import AdvertList from "../../components/AdvertList/index";
  import shoppingCart from './components/shoppingCart.vue'
  import { Popup, Field } from 'mint-ui';

  export default {
    name: "LiveDetails",
    components: {
      JoinCourse,
      AvatarNameCon,
      AvatarGroup,
      Barrage,
      LikeCanvas,
      DialogTip,
      giftAnimate,
      AdPop,
      DailyPop,
      Deblocking,
      [Popup.name]: Popup,
      [Field.name]: Field,
      // AdvertList,
      shoppingCart
    },
    mixins: [sockjs, downloadApp, wx, wxShare, fitVideo, shareBind, viewable],
    data() {
      return {
        type: 2,
        encodeCommand: {
          title: '',
          desc: '',
          channelName: '',
          url: ''
        },
        liveId: 0,
        liveStatus: 0,
        liveData: {
          advertList: []
        },
        avatarList: [],
        fullScreenAd: null,
        fullScreenAdVisible: false,
        newMsg: {},
        newGift: {},
        aliplayer: null,
        txplayer: null,
        attentionDialog: false,
        isPlay: false,
        connectStatus: 0, // 0无连麦  1连麦中  2被邀请连麦
        groupQrcode: '',
        barragePopupVisible: false,
        barrageContent: '',
        loginClass: {},
        shoppingCartVisible: false
      }
    },
    created() {},
    mounted() {
      this.liveId = this.$route.query.id
      this.freeCode = this.$route.query.free_code
      if (this.freeCode && !getToken()) {
        this.handleLogin()
      } else {
        this.preFetchData()
      }

      // 兼容ios自动播放，部分机型不兼容
      const { isiphone } = getPlatform()
      document.addEventListener('WeixinJSBridgeReady', () => {
        if (isiphone) {
          const interval = setInterval(() => {
            // if (this.aliplayer) {
            //   this.aliplayer.mute()
            //   this.aliplayer.play()
            //   clearInterval(interval)
            // }
            if (this.txplayer) {
              this.txplayer.play()
              clearInterval(interval)
            }
          }, 500)
        }
      })

      window.addEventListener('message', this.onMessage)
    },
    computed: {
      coursePrice() {
        return centToYuan(this.liveData.currentPrice)
      },
      canPlay() { // 适用于禁止微信端播放时只显示预告图advanceImg、底部引导按钮，不显示aliplayer、关注频道、立即播放按钮、直播暂停结束状态、连麦、弹幕、底部操作按钮等
        return !(+this.liveData.lessonId) && !(+this.liveData.onlyApp)
      },
      showBroadCastBg() {
        return (+this.liveData.showType === 2) && ( +this.liveStatus === 1 || +this.liveStatus === 3 )
      },
      openAppConfig() {
        return {
          type: 'act',
          url: `yixinli://open_live_play?live_id=${this.liveId}`,
          errIosUrl: "https://sdata.xinli001.com/r/ua",
          errAndroidUrl: "https://sdata.xinli001.com/r/ua"
        }
      },
      userInfo() {
        return this.loginClass.userInfo || {}
      },
      isYixinliApp() {
        return getPlatform().isYixinliApp
      }
    },
    watch: {
      fullScreenAd(fullScreenAd) {
        if (fullScreenAd) {
          this.fullScreenAdVisible = true
        }
      }
    },
    methods: {
      preFetchData() {
        if (!$platform.isYixinliApp) {
          const isWechat = $platform.isWechat

          this.loginClass.fetchUserInfo().then(() => {
            this.handleLogin()
            this.fetchData()
          }).catch(() => {
            if (isWechat) {
              this.$toast('请先登录')
              this.handleLogin()
            } else {
              this.fetchData()
            }
          })
        } else {
          this.fetchData()
        }
      },
      async fetchData(isReset) {
        let token = getToken() || this.userInfo.token
        const res = await getLiveDetail({
          liveId: this.liveId,
          userType: 0,
          token,
          code: this.freeCode
        })
        if (+res.code === 0) {
          // res.data.advertList = [
          //   {
          //     adTitle: '广告标题广告标题广告标题广告标题广告标题11',
          //     adImg: 'https://ossimg.xinli001.com/20200608/a25177cdf3a2b034306cf6e3866fcda0.jpg',
          //     adUrl: 'https://m.xinli001.com'
          //   },
          //   {
          //     adTitle: '广告标题广告标题广告标题广告标题广告标题123123',
          //     adImg: 'https://ossimg.xinli001.com/20200608/a25177cdf3a2b034306cf6e3866fcda0.jpg',
          //     adUrl: 'https://m.xinli001.com'
          //   },
          // ]
          this.liveData = res.data
          // liveStatus = 0-未开始 1-进行中 2-已结束 3 暂停
          this.liveStatus = this.liveData.liveStatus

          if (!isReset) {
            this.avatarList = res.data.avatarList || []
            this.chatList = res.data.chatList
            this.connectStatus = res.data.hasConnect
            this.special = !!this.liveData.isSelected
            this.isLock = !this.liveData.unlock
            this.groupQrcode = this.liveData.groupQrcode
  
            this.handleMonitorStat('访问直播详情页', {}, '直播-页面访问')
  
            this.$trackPageView('H5_live_details_view', {
              live_id: this.$route.query.id,
              anchor_id: res.data.anchorId,
              live_status: '直播'
            })
  
            // 配置口令参数
            this.encodeCommand.title = this.liveData.liveTitle
            this.encodeCommand.channelName = this.liveData.channelName
            this.encodeCommand.url = 'yixinli://open_live_play?live_id=' + this.liveId
            this.handleCommand()
  
            // 设置微信分享信息
            this.shareConfig = {
              shareTitle: this.liveData.shareTitle,
              shareContent: this.liveData.shareContent,
              shareUrl: this.liveData.shareUrl.replace('xinli001.com', 'xinli001.xin') + `&userId=${getUserId() || ''}`, // 这个分享的地址需要跟config的公众号中配置的JSSDK安全域名一致
              shareCover: this.liveData.shareCover,
            }
            this.handleWxShare()
            // 设置分享统计信息
            this.statistics = {
              liveId: this.liveId,
              type: this.type
            }
            window.parent.postMessage({
              liveData: this.liveData
            }, `https://lx${this.env}.xinli001.com`)

          }

          if (this.liveStatus !== 2 && !(+this.liveData.lessonId) && !(+this.liveData.onlyApp)) { 
            // 直播非结束状态、非课程、非仅app可看时才加载播放器
            // 非结束状态的直播才连接ws
            // this.handleAliPlayer(this.liveData)
            this.handleTCPlayer(this.liveData)
            if (!isReset) {
              this.initWebSocket();
            }
          }
        }
      },
      handleTCPlayer(data) {
        const { isAndroid } = getPlatform()
        this.txplayer = TCPlayer('J_prismPlayer_liveDetails', {
          width: '100%',
          height: "100%",
          autoplay: isAndroid,
          preload: true,
          playsinline: false,
          bigPlayButton: false,
          controls: false,
          webrtcConfig: {
            connectRetryCount: 10
          }
        })
        this.txplayer.src(data.urlMap.m3u8Url.replace('http://', '//'));
        // 各种异常状态处理 liveStatus = 0-未开始 1-进行中 2-已结束 3 暂停
        this.txplayer.on('ready', () => {
          console.log('准备')
          /*播放器内置同层播放兼容处理*/
          aliplayerReadyHandle()
        })
        this.txplayer.on('error', (e) => {
          console.log('错误', e)
          this.liveStatus = 3
          this.txplayer && this.txplayer.dispose()
          setTimeout(() => { // 重置播放器
            this.resetPlayer()
          }, 60000)
        })
        this.txplayer.on('ended', () => {
          let token = getToken() || this.userInfo.token
          getLiveDetail({
            liveId: this.liveId,
            userType: 0,
            token,
            code: this.freeCode
          }).then(res => {
            if (+res.code === 0) {
              // liveStatus = 0-未开始 1-进行中 2-已结束 3 暂停
              const liveStatus = res.data.liveStatus
              if(liveStatus === 2) {
                this.liveStatus = 2
                this.txplayer && this.txplayer.dispose()
              }
            }
          })
        })
        this.txplayer.on('playing', () => {
          console.log('播放中')
          this.isPlay = true // 控制播放时不要显示播放按钮
          this.liveStatus = 1
        })
      },
      handleAliPlayer(data) {
        const { isAndroid } = getPlatform()

        this.aliplayer = new Aliplayer({
          id: 'J_prismPlayer_liveDetails',
          width: '100%',
          height: "100%",
          isLive: true,
          preload: true,
          x5_type: 'h5',
          autoplay: isAndroid, // 兼容安卓自动播放，不能自动播放时显示按钮
          playsinline: false, // 不要改为true，否则同层直播不起作用
          x5_fullscreen: true,
          x5_orientation: 'portraint',
          source: data.urlMap.m3u8Url.replace('http://', '//'),  // 兼容协议头 pc下https播放不了m3u8
          mediaType: 'video',
          format: 'm3u8',
          qualitySort: 'asc',
          useH5Prism: true,
          useFlashPrism: false,
          rePlay: false,
          skinLayout: false
        });
        // 各种异常状态处理 liveStatus = 0-未开始 1-进行中 2-已结束 3 暂停
        this.aliplayer.on('ready', () => {
          console.log('准备')
          /*播放器内置同层播放兼容处理*/
          aliplayerReadyHandle()
          if (!this.viewable) {
            this.aliplayer.on('timeupdate', () => {
              let time = this.aliplayer.getCurrentTime()
              console.log(time)
              if (time >= 30) {
                this.aliplayer.pause()
                this.isPlay = false
                if (getToken()) {
                  this.$refs.taskList.showTaskList()
                } else {
                  this.$toast({
                    text: '登录后观看更多',
                    callback: this.handlewxLogin
                  })
                }
              }
            })
            this.aliplayer.setPreviewTime(30)
          }

          /*动态设置video的适应object-fit*/
          this.fitVideo()
        })
        this.aliplayer.on('error', (e) => {
          console.log('错误', e)
          this.liveStatus = 3
          this.aliplayer && this.aliplayer.dispose()
        })
        this.aliplayer.on('ended', () => {
          this.liveStatus = 2
          this.aliplayer && this.aliplayer.dispose()
        })
        this.aliplayer.on('onM3u8Retry', (e) => {
          console.log('m3u8中断错误', e)
          this.aliplayer && this.aliplayer.dispose()
          this.liveStatus = 3
        })
        this.aliplayer.on('liveStreamStop', (e) => {
          this.liveStatus = 3
          console.log('流中断', e)
        })
        this.aliplayer.on('playing', () => {
          console.log('播放中')
          this.isPlay = true // 控制播放时不要显示播放按钮
          this.liveStatus = 1
        })
        // wifi提醒处理
        if (!isWifi()) {
          this.$toast('非wifi状态消耗流量')
        }
      },
      resetPlayer() {
        if (this.canPlay && document.querySelector('#J_prismPlayer_liveDetails') === null) {
          const videoEl = document.createElement('video');
          videoEl.id = 'J_prismPlayer_liveDetails';
          videoEl.style.cssText = 'width:100%;height:100%'
          const liveContainer = document.querySelector('.live-container')
          const firstChild = liveContainer.firstChild;
          firstChild ? liveContainer.insertBefore(videoEl, firstChild) : liveContainer.appendChild(videoEl)
          this.$nextTick(() => {
            this.isPlay = false
            this.fetchData(true)
          })
        }
      },
      playLive() {
        this.txplayer && this.txplayer.play()
        // this.aliplayer && this.aliplayer.play()
        this.isPlay = true
      },
      handleAttention() {
        this.handleMonitorStat(`点击${this.liveData.isStar ? '取消关注频道' : '关注频道'}`)
        let token = getToken()
        let open_id = getOpenId()
        if (token) {
          starChannel({
            channelId: this.liveData.channelId,
            isStar: this.liveData.isStar ? 0 : 1,
            token,
            openId: open_id,
            liveId: this.liveId,
            type: this.type
          }).then(res => {
            if (+res.code === 0) { // 关注成功弹框提示
              if (!this.liveData.isStar) {
                this.attentionDialog = true
                this.attentionDialog = true
              }
              this.liveData.isStar = !this.liveData.isStar
            }
          })
        } else {
          this.handleLogin()
        }
      },
      watchClick() {
        this.handleMonitorStat('点击主播邀你来观看直播入口')
      },
      dreamApply() {
        this.handleMonitorStat('点击解梦申请按钮')
      },
      microConnectApply() {
        this.handleMonitorStat('点击连麦申请按钮')
      },
      reward() {
        this.handleMonitorStat('打赏')
      },
      goToApp() {
        this.handleMonitorStat('点击去App连接')
      },
      likeClick() {
        this.handleMonitorStat('点赞')

        if (!getToken()) {
          this.$toast('请先登录')
          this.handleLogin()
          return
        }

        const userChatVo = {
          userId: this.userInfo.userId,
          nickname: this.nickName,
          content: '',
          channelId: this.liveData.channelId,
          liveId: this.liveId,
          avatar: this.userInfo.avatar,
          assistant: this.liveData.assistant,
          type: 2
        }
        this.sendMsg(userChatVo)
      },
      closeAttentionDialog() {
        this.handleMonitorStat('点击关闭二维码弹框')
        this.attentionDialog = false
      },
      dragOperation() {

      },
      openBarragePopup() {
        if (!getToken()) {
          this.$toast('请先登录')
          this.handleLogin()
          return
        }
        this.barragePopupVisible = true
        this.$nextTick(() => {
          document.querySelector('.mint-field-core').focus()
        })
      },

      handleSendBarrage() {
        if (!this.barrageContent) {
          this.$toast('弹幕内容不能为空')
          return
        }
        const userChatVo = {
          userId: this.userInfo.userId,
          nickname: this.nickName,
          content: this.barrageContent,
          channelId: this.liveData.channelId,
          liveId: this.liveId,
          avatar: this.userInfo.avatar,
          assistant: this.liveData.assistant,
        }
        this.sendMsg(userChatVo)
        this.barragePopupVisible = false
        this.barrageContent = ''

        this.handleMonitorStat('发送弹幕', userChatVo)
      },

      handleMonitorStat(bucket, params={}, title='直播-交互行为') {
        window.monitor && window.monitor.stat({
          logType: 'info',
          level: 'info',
          title: title,
          remark: bucket,
          userId: this.userId,
          message: JSON.stringify({
            直播间id: this.liveId,
            页面title: this.liveData.liveTitle,
            nickname: this.nickName,
            ...params
          })
        })
      },

      updateAdvertList(advertList) {
        this.liveData.advertList = advertList
      },

      updateAdvert(msg) {
        const { liveRoomAdImg, liveRoomAdUrl, liveRoomAdTitle } = msg
        this.liveData.liveRoomAdImg = liveRoomAdImg
        this.liveData.liveRoomAdUrl = liveRoomAdUrl
        this.liveData.liveRoomAdTitle = liveRoomAdTitle
      },

      updateFullScreenAd(list) {
        this.fullScreenAd = list && list.length ? list[0] : null
      },

      onMessage(e) {
        if (e.origin === `https://lx${this.env}.xinli001.com` && e.data) {
          if (e.data.userChatVo) {
            this.sendMsg(e.data.userChatVo)
          }
        }
      }
    },
    beforeDestroy() {
      this.txplayer && this.txplayer.dispose()
      // this.aliplayer && this.aliplayer.dispose()
      window.removeEventListener('message', this.onMessage)
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .prism-player {
    background: transparent;
  }

  /*/deep/ video {*/
  /*  object-fit: contain !important;*/
  /*}*/

  .aliplayer-contain {
    /deep/ video {
      object-fit: contain !important;
    }
  }

  .aliplayer-cover {
    /deep/ video {
      object-fit: contain !important;
    }
  }

  .play-btn {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, 0);
    padding: 30px;
    border-radius: 20px;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 99;
    text-align: center;

    .play-img {
      margin-bottom: 30px;
      width: 120px;
      height: 120px;
    }
  }

  .connect-micro-sec {
    position: absolute;
    right: 30px;
    bottom: 336px;

    .micro-connect {
      padding: 48px 18px 30px 18px;

      background: rgba(0, 0, 0, .7);
      border-radius: 30px;
      text-align: center;
      font-size: 24px;

      p {
        margin-bottom: 30px;

        color: #FFFFFF;
      }

      div {
        padding: 18px 14px;

        background: #6982FA;
        border-radius: 30px;
      }
    }

    .micro-connecting {
      padding: 20px 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      background: rgba(0, 0, 0, .7);
      border-radius: 30px;
      text-align: center;
      font-size: 24px;

      img {
        margin-bottom: 10px;
        width: 40px;
      }
    }
  }

  .live-container {
    position: relative;
    height: 100vh;
    width: 100%;
    overflow: hidden;

    background-color: rgba(0, 0, 0, .8);
    color: #fff;
    font-size: 26px;

    .player-container {
      width: 100%;
      height: 100%;
    }

    .pre-img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
    }

    .living-content {
      width: 100%;
      height: 100%;
      &.broadcast {
        position: absolute;
        top: 0;
        left: 0;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100%;
      }
    }

    .section {
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px;
    }

    .section-bottom {
      padding: 30px;
    }

    /deep/ .v-modal {
      z-index: 10 !important;
    }
  }

  .section-right {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .svg-icon {
      margin-left: 30px;
    }
  }

  .special {
    position: absolute;
    top: 150px;
    left: 30px;
    width: 100px;
    line-height: 48px;
    text-align: center;
    background-image: linear-gradient(90deg, #FF9A9A 0%, #FF3778 100%);
    border-radius: 24px 24px 24px 8px;
    font-size: 22px;
    color: #FFFFFF;
  }

  .ad-pop-outside {
    position: absolute;
    right: 10px;
    bottom: 120px;
    z-index: 9;
  }

  .live-pause {
    position: absolute;
    top: 400px;
    width: 100%;

    font-size: 36px;
    text-align: center;

    .btn {
      margin: 0 auto;
      margin-top: 48px;
      padding: 16px 50px;
      width: fit-content;

      border: 1px solid #fff;
      border-radius: 36px;
      font-size: 28px;
    }
  }

  .end-con {
    position: absolute;
    top: 40%;
    width: 100%;
    font-size: 36px;
    text-align: center;
  }

  .section-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    .daily-handle {
      position: absolute;
      bottom: 400px;
      right: 30px;
    }

    .barrage-con {
      width: 490px;

      .assistant-con {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 30px;
        line-height: 30px;
        margin: 2px 10px 0 0;
        float: left;

        background-image: linear-gradient(121deg, #FF8A74 0%, #6982FA 100%);
        border-radius: 8px;
        font-size: 20px;

        .assisstant-img {
          margin-right: 6px;
          width: 16px;
          height: 18px;
        }
      }

      .item-con {
        color: rgba(255, 255, 255, .8);

        .content {
          font-weight: bold;
          color: #fff;
        }
      }

      .msg-item {
        max-width: 100%;
        word-break: break-all;
        margin: 5px 0;
        padding: 10px 20px;
        width: fit-content;
        box-sizing: border-box;
        word-wrap: break-word;
        overflow-wrap: break-word;

        background-color: rgba(0, 0, 0, .3);
        border-radius: 24px;
        font-size: 24px;
        line-height: 1.25;
      }

      .join-item {
        font-family: PingFangSC-Medium;


        .content {
          padding-left: 12px;
          font-family: PingFangSC-Regular;
        }
      }

      .attention-item {
        font-family: PingFangSC-Medium;
        background-color: rgba(255,142,2,.6);

        .content {
          padding-left: 12px;
          font-family: PingFangSC-Regular;
        }
      }

      .gift-item {
        .content {
          padding-left: 12px;
          color: #FFED5A;
        }
      }
    }
  }

  .live-fun-container {
      display: flex;
      justify-content: space-between;

      .barrage-btn {
        padding: 16px 48px 16px 24px;
        display: flex;
        align-items: center;
        line-height: 1;

        .func-btn {
          margin-right: 10px;
        }
      }

      .left-btn {
        padding: 16px 24px;

        border-radius: 36px;
        background-color: rgba(0, 0, 0, .3);
        color: rgba(255, 255, 255, .8);
        font-size: 28px;

        .svg-icon {
          margin-bottom: 3px;
          fill: #fff;
          font-size: 18px;
        }
      }

      .btn-group {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .bottom-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          margin: 0 15px;
          width: 72px;
          height: 72px;

          border-radius: 50%;
          background-color: rgba(0, 0, 0, .3);

          .tag {
            position: absolute;
            top: 0px;
            right: -24px;
            width: 40px;
          }

          .num {
            position: absolute;
            top: -14px;
            left: 50%;
            transform: translateX(-50%);
            height: 24px;
            padding: 0 12px;
            display: flex;
            align-items: center;
            justify-content: center;

            word-break: keep-all;
            font-size: 18px;
            background: #FF4A4A;
            border-radius: 12px;
          }

          img {
            width: 36px;
          }
        }

        .cover-btn {
          img {
            width: 100%;
          }
        }

        .cart-btn {
          margin-right: 0;
          img {
            width: 42px;
          }
        }
      }
  }

  .like-container {
    display: flex;
    justify-content: center;
    align-items: center;

    /deep/ canvas {
      position: absolute;
      bottom: 60px;
    }
  }

  .dialog-content {
    .conteng-title {
      font-size: 38px;
      color: #21252D;
      font-weight: bold;
    }

    .content-subheading {
      padding-top: 20px;
      font-size: 28px;
      color: #6C798C;
      line-height: 48px;

      span {
        color:  #6982FA;
      }
    }

    .content-tip {
      padding: 48px 0 30px 0;
      font-size: 26px;
      color: #6C798C;
      line-height: 48px;
    }

    .content-scan {
      width: 300px;
      height: 300px;
      margin: 0 auto;

      .scan-img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .course-con {
    max-width: 10rem;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0 auto;
  }

  .download-con {
    max-width: 10rem;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0 auto;

    padding: 26px 0;
    background: #6982FA;
    border-radius: 20px 20px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    color: #FFFFFF;
    font-weight: bold;

    .svg-icon {
      margin-bottom: 3px;
      fill: #fff;
      font-size: 18px;
    }
  }

  .barrage-input {
    width: 100%;
    padding: 0 20px 20px;
    background: #f8f8f8;
    box-sizing: border-box;

    .input-header {
      height: 80px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #21252D;

      .btn-close, .btn-confirm {
        font-size: 28px;
        color: #6982FA;
        font-weight: 400;
      }
      .title {
        font-size: 30px;
      }
    }

    /deep/ {
      .mint-cell-wrapper {
        background: #fff;
        font-size: 28px;
        border-radius: 8px;

        textarea {
          resize: none;
        }
      }
    }
  }

  .full-screen-ad {
    position: relative;
    width: 600px;
    max-height: 80vh;
    object-fit: contain;

    .close-btn {
      position: absolute;
      padding: 10px;
      bottom: -80px;
      left: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: rgba($color: #fff, $alpha: .4);

      i {
        position: relative;
        display: inline-block;
        width: 20px;
        height: 20px;
        border: none;
        background-color: transparent;
        cursor: pointer;
      }
  
      i::before, i::after {
        content: '';
        display: block;
        position: absolute;
        width: 2px;
        background-color: #fff;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
  
      i::before {
        transform: rotate(45deg);
      }
  
      i::after {
        transform: rotate(-45deg);
      }
    }
  }
</style>
